export default __webpack_public_path__ + "static/media/plb-logo-white.52bfdc41.svg";